//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Referrals',
  data() {
    return {
      imgUrl: 'https://static.moele.me/img/signup/contributors/220518/contributors-signup-referral.png',
    };
  },
};
